var h = require('hyperscript')

module.exports = {
  url: '/contact',
  template: require('raw!templates/contact/contact.html'),
  controller: ContactController,
  controllerAs: 'contactCtrl'
}

function ContactController ($scope, $state, store, contentful,  $uibModal, $window, NgMap, $http, emailSvc) {
  var vm = this;
  NgMap.getMap().then(function(map) {
  $scope.map = map;
  $scope.map.setOptions({ draggable: false, zoomControl: false, scrollwheel: false, disableDoubleClickZoom: true});
  });
  $scope.custom = true
  $scope.custom1 = true
  $scope.custom2 = true
  $scope.page = 'contact'
  contentful.entries('content_type=contactPage').then(function(res) {
    $scope.contentfulData = res.data.items[0];
    // console.log('data', $scope.contentfulData);
  })
  contentful.entries('content_type=contactPage').then(function(res) {
    var seoData = res.data.items[0];
    if (seoData.fields.pageTitleSeo) {
      document.title = seoData.fields.pageTitleSeo;
    }
    if (seoData.fields.pageSpecificMetaDescriptionSeo) {
      var meta = document.getElementsByTagName("meta");
      for (var i = 0; i < meta.length; i++) {
        if (meta[i].name.toLowerCase() === "description") {
          meta[i].content = seoData.fields.pageSpecificMetaDescriptionSeo;
        }
      }
    }
  });
  contentful.entries('content_type=locations').then(function(res) {
    $scope.allOffices = res.data.items;
    $scope.officeLocation = res.data.items[0];
    // console.log('offices', $scope.allOffices);
  })
  $scope.currentLocation = 'currentLocation'
  $scope.setLocation = function (location) {
    if(location === 'charleston') {
      $scope.map.setCenter(new google.maps.LatLng(32.846610, -79.979790))
      $scope.map.setZoom(16)
      $scope.currentLocation = 'charleston'
    } else if (location === 'charlotte') {
      $scope.map.setCenter(new google.maps.LatLng(35.15851, -80.8884))
      $scope.map.setZoom(16)
      $scope.currentLocation = 'charlotte'
    } else if (location === 'ballentine') {
      $scope.map.setCenter(new google.maps.LatLng(34.125178, -81.23645420000003))
      $scope.map.setZoom(16)
      $scope.currentLocation = 'ballentine'
    } else if (location === 'jacksonville') {
      $scope.map.setCenter(new google.maps.LatLng(30.2924042, -81.62675969999998))
      $scope.map.setZoom(16)
      $scope.currentLocation = 'jacksonville'
    }
  }


  $scope.setMarker = function(office) {

    var markerLat = office.latLng.lat()
    var markerLon = office.latLng.lng()
  }

  $scope.showOffice = function(event, officeId) {
    $scope.office = $scope.allOffices[officeId];
   $scope.map.showInfoWindow('foo', this);
  };

  $scope.sendContact = function(){
  }
  $scope.contactForm = {
     'contactInfo': '',
     'email': '',
     'name': '',
     'message': '',
     'phone': '',
     'subject': ''
   }
   $scope.submitForm = function(invalidStatus, form) {
        if(!invalidStatus) {
            $scope.contactThankYou = true
            window.setTimeout(function() {
              form.$setPristine();
              $scope.contactThankYou = false
              $scope.contactForm = {
                 'contactInfo': '',
                 'email': '',
                 'name': '',
                 'message': '',
                 'phone': '',
                 'subject': ''
               }
              $scope.$apply();
            }, 20000);

            if ($scope.contactForm.contactInfo === '') {
              var url =  "/email/send"
              var obj = $scope.contactForm

              emailSvc.send(obj).then(function success() {
                $http.post(url, obj).then(function success() {
                  })
                })
              } else {
                // console.log('spam')
              }
        } else {
            // console.log('invalid form')
        }
    }
  }



/** WEBPACK FOOTER **
 ** ./components/templates/contact/contact.js
 **/